import Web3 from "web3";
import { getNodeListAddresses } from "@/contract";

/**
 * @param {string} raw 用户输入
 * @returns {string|null} checksum 地址或 null
 */
export function normalizeNodeAddressInput(raw) {
  const s = String(raw || "").trim();
  if (!s || !Web3.utils.isAddress(s)) return null;
  return Web3.utils.toChecksumAddress(s);
}

/** @returns {Promise<string[]>} */
export function fetchNodeAddressList() {
  return getNodeListAddresses();
}
